import { render, staticRenderFns } from "./ModalAddSeries.vue?vue&type=template&id=bec4b918&scoped=true&"
import script from "./ModalAddSeries.vue?vue&type=script&lang=js&"
export * from "./ModalAddSeries.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddSeries.vue?vue&type=style&index=0&id=bec4b918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec4b918",
  null
  
)

export default component.exports